import {
    ILicense,
    ILicenseFields,
    LicenseConsumerType,
} from '@models';

import cloneDeep from 'lodash-es/cloneDeep';

export const licensedFilterList = () =>
    cloneDeep([{
        value: false,
        label: 'Unlicensed',
        translationKey: 'LicensedType_Unlicensed',
    }, {
        value: true,
        label: 'Licensed',
        translationKey: 'LicensedType_Licensed',
    }]);

export const WARNING_LEVELS = {
    'filling-soon': 61,
    'filling-imminent': 86,
};

export interface ILicenseDefinition {
    key: keyof ILicenseFields;
    translationKey: (license?: ILicense) => string;
    consumerType: (license?: ILicense) => LicenseConsumerType;
    descriptionTag: string;
    descriptionConcurrentTag: string;
    url: string;
}

export const LICENSE_DEFINITIONS = [
    {
        key: 'attended',
        translationKey: (license: ILicense) => `RobotType_Attended${license.attendedConcurrent ? '_Concurrent' : ''}`,
        consumerType: (license: ILicense) => license.attendedConcurrent ? LicenseConsumerType.Connection : LicenseConsumerType.User,
        descriptionTag: 'LicenseDescription_Attended',
        descriptionConcurrentTag: 'LicenseDescription_Attended_Concurrent',
        url: 'attended',
    },
    {
        key: 'unattended',
        translationKey: () => 'RobotType_Unattended',
        consumerType: () => LicenseConsumerType.Device,
        descriptionTag: 'LicenseDescription_Unattended',
        descriptionConcurrentTag: null,
        url: 'unattended',
    },
    {
        key: 'development',
        translationKey: (license: ILicense) => `RobotType_Development${license.developmentConcurrent ? '_Concurrent' : ''}`,
        consumerType: (license: ILicense) => license.developmentConcurrent ? LicenseConsumerType.Connection : LicenseConsumerType.User,
        descriptionTag: 'LicenseDescription_Development',
        descriptionConcurrentTag: 'LicenseDescription_Development_Concurrent',
        url: 'development',
    },
    {
        key: 'studioX',
        translationKey: (license: ILicense) => `RobotType_StudioX${license.studioXConcurrent ? '_Concurrent' : ''}`,
        consumerType: (license: ILicense) => license.studioXConcurrent ? LicenseConsumerType.Connection : LicenseConsumerType.User,
        descriptionTag: 'LicenseDescription_StudioX',
        descriptionConcurrentTag: 'LicenseDescription_StudioX_Concurrent',
        url: 'studiox',
    },
    {
        key: 'nonProduction',
        translationKey: () => 'RobotType_NonProduction',
        consumerType: () => LicenseConsumerType.Device,
        descriptionTag: 'LicenseDescription_NonProduction',
        descriptionConcurrentTag: null,
        url: 'nonproduction',
    },
] as ILicenseDefinition[];
